import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import { fetchSeminar } from '@/lib/seminar'
import { Seminar } from '../../types'
import Error from '../_error'
import { EmbedMarketoFormTemplate } from '@/components/pages/enterprise/templates/EmbedMarketoFormTemplate'
import { SeminarHead } from '@/components/common/Head'

type Props = {
  seminar?: Seminar
}

const SeminarPage: NextPage<Props> = (props) => {
  if (!props.seminar) {
    return <Error />
  }

  return (
    <>
      <SeminarHead seminar={props.seminar} />
      <EmbedMarketoFormTemplate content={props.seminar} type={'seminar'} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  const { slug } = ctx.params as { slug: string }
  const seminar = await fetchSeminar(slug)
  return { props: seminar ? { seminar } : {} }
}

export default SeminarPage
